import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Certifications from "../components/Certifications";
import Features from "../components/Features";
import Reviews from "../components/Reviews";
import Quote from "../components/Quote";
import Team from "../components/Team";

const Home: React.FC = () => {
  return (
    <div>
      <Navbar />
      <div id="Hero">
        <Hero />
      </div>
      <div id="Features">
        <Features />
      </div>
      <div id="Certifications">
        <Certifications />
      </div>
      <div id="Team">
        <Team />
      </div>
      <div id="Reviews">
        <Reviews />
      </div>
      <div id="FreeQuote">
        <Quote />
      </div>
    </div>
  );
};

export default Home;
